import { useCallback, useEffect, useState } from 'react';
import { useCognitoRegistration } from '../../../../../shared/services/authentication';
import { ALL_FIELDS_REQUIRED, LOGIN, PASSWORD_DO_NOT_MATCH, } from '../constants';
import RegistrationFields from '../../configs/registration_fields.json';
import VerificationFields from '../../configs/verification_code_fields.json';
import { useCommon } from './useCommon';
export function useRegistration(defaultInput, onComplete, signinOrRegisterLink, cognitoUserPoolConfig) {
    const { handleInputChange, LinkComponent, inputs } = useCommon(defaultInput, LOGIN, 'Already have an account?', signinOrRegisterLink);
    const [missingFields, setMissingFields] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [buttonLabel, setButtonLabel] = useState('Register');
    const [formFields, setFormFields] = useState(RegistrationFields);
    const { userRegDetails, signupUser, confirmRegistration, isFetching } = useCognitoRegistration(cognitoUserPoolConfig);
    const onRegistration = useCallback(() => {
        if (inputs.email &&
            inputs.password &&
            inputs.fullName &&
            inputs.phone &&
            inputs.confirmPassword &&
            inputs.password === inputs.confirmPassword) {
            setMissingFields(false);
            setPasswordMatch(true);
            signupUser(inputs.password, inputs.fullName, inputs.email, inputs.phone);
        }
        else if (inputs.password !== inputs.confirmPassword) {
            setPasswordMatch(false);
            setErrorMsg(PASSWORD_DO_NOT_MATCH);
        }
        else {
            setMissingFields(true);
            setErrorMsg(ALL_FIELDS_REQUIRED);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputs]);
    const onRegistrationConfirm = useCallback(() => {
        if (inputs.verificationCode) {
            setMissingFields(false);
            confirmRegistration(inputs.verificationCode);
        }
        else {
            setMissingFields(true);
            setErrorMsg(ALL_FIELDS_REQUIRED);
        }
    }, [confirmRegistration, inputs.verificationCode]);
    useEffect(() => {
        if (!userRegDetails.registrationErrorMsg &&
            (userRegDetails.regCompleted || userRegDetails.userConfirmed)) {
            onComplete(userRegDetails);
        }
    }, [onComplete, userRegDetails]);
    useEffect(() => {
        if (userRegDetails.regCompleted) {
            setButtonLabel('Confirm Account');
            setFormFields(VerificationFields);
        }
    }, [userRegDetails]);
    const authError = missingFields || !passwordMatch
        ? errorMsg
        : userRegDetails.registrationErrorMsg;
    const onSubmit = userRegDetails.regCompleted
        ? onRegistrationConfirm
        : onRegistration;
    return {
        handleInputChange,
        onSubmit,
        formFields,
        LinkComponent,
        authError,
        buttonLabel,
        isFetching,
    };
}
//# sourceMappingURL=useRegistration.js.map